import { useTranslation } from 'react-i18next';

export type OrderStatus = keyof typeof ORDER_STATUS;
export type PaymentStatus = keyof typeof PAYMENT_STATUS;

export const ORDER_STATUS = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    IN_DELIVERY: 'IN DELIVERY',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
};

export const ORDER_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    PENDING: 'warning',
    IN_DELIVERY: 'warning',
    ACCEPTED: 'success',
    COMPLETED: 'success',
    REJECTED: 'error',
    CANCELLED: 'error',
};

export const useOrderStatus = () => {
    const { t } = useTranslation();
    return {
        PENDING: t('STATUS.PENDING'),
        ACCEPTED: t('STATUS.ACCEPTED'),
        IN_DELIVERY: t('STATUS.IN_DELIVERY'),
        COMPLETED: t('STATUS.COMPLETED'),
        REJECTED: t('STATUS.REJECTED'),
        CANCELLED: t('STATUS.CANCELLED'),
    };
};

export const useFilterSelectOptions = () => {
    const orderStatus = useOrderStatus();

    return Object.keys(orderStatus).map((status) => ({
        value: status,
        label: orderStatus[status],
    }));
};

export const PAYMENT_STATUS = {
    SUCCESS: 'SUCCESS',
    NOT_INITIATED: 'NOT_INITIATED',
    CANCELED: 'CANCELED',
    FAILED: 'FAILED',
};

export const useOrderPaymentStatus = () => {
    const { t } = useTranslation();
    return {
        SUCCESS: t('STATUS.SUCCESS'),
        NOT_INITIATED: t('STATUS.NOT_INITIATED'),
        CANCELED: t('STATUS.CANCELED'),
        FAILED: t('STATUS.FAILED'),
    };
};

export const PAYMENT_STATUS_COLOR = {
    SUCCESS: 'success',
    NOT_INITIATED: 'warning',
    CANCELED: 'error',
    FAILED: 'error',
};
